import React from 'react'
import { Box } from '@material-ui/core'
import { Controller } from 'react-hook-form'
import { Select } from 'components'
import constants from 'constants/index'

const LegalBasisForm = ({ control, errors, watch }) => {
  return (
    <Box display="flex" width="100%" paddingBottom={1}>
      <Controller
        control={control}
        name="legalFrameworkName"
        as={
          <Select
            items={constants.consentFormReports.LEGAL_FRAMEWORK_FORM_OPTIONS}
            error={!!errors.legalFrameworkName}
            helperText={errors?.legalFrameworkName?.message}
            label="Selecione o formulário"
          />
        }
        mode="onChange"
      />
    </Box>
  )
}

export default LegalBasisForm
